"use client";

import { useEffect, useId, useRef, useState } from "react";

import type { Dictionary } from "@/dictionaries/types";
import { SecGlyph } from "@/features/home-v2/ornament";
import type { DetailModel } from "../model";

type Labels = Dictionary["collectionPage"];

/** Two lines of the story, and "more" only when the clamp hides something
 *  (re-measured on resize — the same text clamps at 320px and not at 1280px). */
export function Story({ text, t }: { text: string; t: Labels }) {
  const [open, setOpen] = useState(false);
  const [clamped, setClamped] = useState(false);
  const ref = useRef<HTMLParagraphElement>(null);
  const id = useId();
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setClamped(el.scrollHeight > el.clientHeight + 1);
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [text, open]);
  return (
    <div className="vt-story" role="group" aria-label={t.descriptionRegion}>
      <p ref={ref} id={id} data-open={open || undefined}>{text}</p>
      {clamped || open ? <button type="button" className="vt-more v2-focus" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls={id}>{open ? t.showLess : t.showMore}</button> : null}
    </div>
  );
}

/**
 * «درباره» — the collection's own words, and nothing else (its links are on
 * the action plaque). A description that only repeats the collection's name
 * is not shown (see `story` in the model), and then there is no shelf.
 */
export default function AboutShelf({ m, t, isFa }: { m: DetailModel; t: Labels; isFa: boolean }) {
  if (!m.story) return null;
  return (
    <section className="vt-about" aria-label={isFa ? "درباره‌ی این کالکشن" : "About this collection"}>
      <SecGlyph className="vt-about-glyph" />
      {m.story ? <Story text={m.story} t={t} /> : null}
    </section>
  );
}
